module.exports = {
          srcSet: __webpack_public_path__ + "c7e279af76191794c74973f5fd72197a-16.png"+" 16w",
          images:[ {path: __webpack_public_path__ + "c7e279af76191794c74973f5fd72197a-16.png",width: 16,height: 16}],
          src: __webpack_public_path__ + "c7e279af76191794c74973f5fd72197a-16.png",
          toString:function(){return __webpack_public_path__ + "c7e279af76191794c74973f5fd72197a-16.png"},
          
          width: 16,
          height: 16
        }